import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentModernText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    viewBox="0 0 24 25" {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 12.5h10"
    />
    <rect
      width={18}
      height={18}
      x={3}
      y={3.5}
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={4}
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 16.5h10M7 8.5h5"
    />
  </svg>
);
export default SvgDocumentModernText;
